<div class="app-main__inner">
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon">
          <i class="pe-7s-upload icon-gradient bg-mean-fruit"></i>
        </div>
        <div>
          Upload Documents
          <div class="page-title-subheading">Upload HR documents for employees.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-3 card">
    <div class="card-body">

      <div *ngIf="uploadMessage" class="alert" [ngClass]="uploadSuccess ? 'alert-success' : 'alert-danger'" role="alert">
        {{ uploadMessage }}
      </div>

      <form (ngSubmit)="upload()" #uploadForm="ngForm">
        <div class="row">

          <div class="col-md-6 mb-3">
            <label class="form-label" for="docTypeSelect">Document Type <span class="text-danger">*</span></label>
            <select
              id="docTypeSelect"
              class="form-select"
              name="docType"
              [(ngModel)]="selectedDocType"
              (ngModelChange)="onDocTypeChange()"
              required
            >
              <option [ngValue]="null" disabled>Select document type</option>
              <option *ngFor="let dt of docTypes" [ngValue]="dt">{{ dt.documentName }}</option>
            </select>
            <div class="form-text" *ngIf="selectedDocType">
              Period: <strong>{{ selectedDocType.documentPeriod }}</strong> &nbsp;|&nbsp;
              Type: <strong>{{ selectedDocType.documentFrequency }}</strong>
            </div>
          </div>

        </div>

        <ng-container *ngIf="selectedDocType">
          <div class="row">

            <!-- Conditional Access: show authorized employees from the document type master (read-only) -->
            <ng-container *ngIf="isConditionalAccess">
              <div class="col-12 mb-3">
                <label class="form-label">Authorized Employees</label>
                <div *ngIf="selectedDocType && selectedDocType.authorizedEmpNos.length; else noEmpNos"
                     class="border rounded p-2 bg-light" style="min-height: 60px;">
                  <span *ngFor="let empNo of selectedDocType!.authorizedEmpNos; let last = last"
                        class="badge bg-primary me-1 mb-1">{{ empNo }}</span>
                </div>
                <ng-template #noEmpNos>
                  <div class="alert alert-warning mb-0 py-2">
                    No employees are authorized for this document type. Edit the document type in Document Type Master to add employees.
                  </div>
                </ng-template>
                <div class="form-text">
                  These employees are configured in the Document Type Master. The document will be uploaded for each of them.
                </div>
              </div>
            </ng-container>

            <!-- Individual: single employee -->
            <ng-container *ngIf="!isConditionalAccess && !isMonthly && !isCommon">
              <div class="col-md-6 mb-3">
                <label class="form-label" for="empSelect">Employee <span class="text-danger">*</span></label>
                <select
                  id="empSelect"
                  class="form-select"
                  name="empNo"
                  [(ngModel)]="selectedEmpNo"
                  required
                >
                  <option value="" disabled>Select employee</option>
                  <option *ngFor="let e of employees" [value]="e.empNo">{{ e.name }} ({{ e.empNo }})</option>
                </select>
              </div>
            </ng-container>

            <!-- Yearly period: year only -->
            <div class="col-md-6 mb-3" *ngIf="selectedDocType.documentPeriod === 'Yearly'">
              <label class="form-label" for="yearSelect">Year <span class="text-danger">*</span></label>
              <select id="yearSelect" class="form-select" name="forYear" [(ngModel)]="forYear" required>
                <option value="" disabled>Select year</option>
                <option *ngFor="let y of years" [value]="y">{{ y }}</option>
              </select>
            </div>

            <!-- Monthly period (Conditional Access / Common): month + year -->
            <!-- Individual Monthly goes to bulk payslip and doesn't need these fields -->
            <ng-container *ngIf="selectedDocType.documentPeriod === 'Monthly' && (isConditionalAccess || isCommon)">
              <div class="col-md-3 mb-3">
                <label class="form-label" for="monthSelect">Month <span class="text-danger">*</span></label>
                <select id="monthSelect" class="form-select" name="forMonth" [(ngModel)]="forMonth" required>
                  <option value="" disabled>Select month</option>
                  <option *ngFor="let m of months" [value]="m">{{ m }}</option>
                </select>
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label" for="monthYearSelect">Year <span class="text-danger">*</span></label>
                <select id="monthYearSelect" class="form-select" name="forYear" [(ngModel)]="forYear" required>
                  <option value="" disabled>Select year</option>
                  <option *ngFor="let y of years" [value]="y">{{ y }}</option>
                </select>
              </div>
            </ng-container>

            <div class="col-md-6 mb-3">
              <label class="form-label" for="docFile">PDF File <span class="text-danger">*</span></label>
              <input
                id="docFile"
                type="file"
                class="form-control"
                accept=".pdf,application/pdf"
                (change)="onFileSelected($event)"
              />
              <div class="form-text">Only PDF files are accepted.</div>
            </div>

          </div>

          <div class="mt-2">
            <button type="submit" class="btn btn-primary" [disabled]="!isFormValid || isUploading">
              {{ isUploading ? 'Uploading...' : 'Upload Document' }}
            </button>
          </div>
        </ng-container>
      </form>

    </div>
  </div>
</div>
